const CHART_CONTAINER_IN_VIEW_CONFIG = {
  once: true,
  offset: '200px'
};

const CHART_IN_VIEW_CONFIG = {
  once: true,
  offset: '0px'
};

export { CHART_CONTAINER_IN_VIEW_CONFIG, CHART_IN_VIEW_CONFIG };
